<template>
  <b-dropdown no-caret right class="lang-dropdown">
    <template v-slot:button-content>
      <div style="display: flex">
        <img src="@/assets/images/ic-lang-black.svg"/>
        <div class="mx-2 text-body-1"> {{ selectedLang.text }}</div>
        <img src="@/assets/images/ic-dropdown-black.svg"/>
      </div>
    </template>

    <b-dropdown-item
        @click="changeLocale(languages[0].value)">
      <b-checkbox :class="'lang-cb ' + (checkVi ? 'lang-cb-highlight': '')" v-model="checkVi">
        {{ languages[0].text }}
      </b-checkbox>
    </b-dropdown-item>
    <b-dropdown-item
        @click="changeLocale(languages[1].value)">
      <b-checkbox :class="'lang-cb ' + (checkEn ? 'lang-cb-highlight': '')" v-model="checkEn">
        {{ languages[1].text }}
      </b-checkbox>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import store from "../store";
import {mapState} from "vuex";

export default {
  name: "DefaultHeaderChangeLanguage",
  computed: {
    ...mapState(['locale']),
    selectedLang() {
      let selectedLang = this.languages.find(lang => lang.value === this.locale);
      if (selectedLang) {
        this.checkVi = selectedLang.value === 'vi'
        this.checkEn = selectedLang.value === 'en'
        return selectedLang
      }
      return this.languages[0]
    },
  },
  data: () => ({
    languages: [
      {text: "Tiếng Việt", value: "vi"},
      {text: "English", value: "en"},
    ],
    checkVi: true,
    checkEn: false
  }),
  methods: {
    changeLocale(locale) {
      if (store.state.locale !== locale) {
        this.checkVi = locale === 'vi'
        this.checkEn = locale === 'en'
        store.dispatch("setLang", locale);
      }
    },
  },
};
</script>


<style scoped>

.lang-dropdown >>> .btn-secondary {
  color: #000;
  background: #fff;
  border-color: #fff;
}

.lang-dropdown >>> .btn-secondary:active {
  background: #eee;
  border-color: #eee;
  box-shadow: #fff;
}

.lang-dropdown >>> .btn-secondary:focus {
  box-shadow: none;
}

.lang-dropdown >>> .dropdown-menu {
  padding-left: 0;
}

.lang-dropdown >>> .dropdown-item.active, .dropdown-item:active {
  color: #fff;
  background-color: #E6F7FF;
}

.lang-dropdown >>> .dropdown-item:hover, .dropdown-item:focus {
  color: #1890FF;
  background-color: #E6F7FF;
}

.lang-cb {
  color: #000000;
}

.lang-cb:hover {
  color: #1890FF;
}

.lang-cb-highlight {
  color: #1890FF;
}

.lang-cb >>> .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #1890FF;
  background-color: #1890FF;
}

.lang-cb >>> .custom-control-label::before {
  border-color: #D9D9D9;
}

</style>
